// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VQwYHLv95kI2qg0II_mb{justify-content:space-between;align-items:center;display:flex}.Sg05SFA4KAGs2MKwBxoQ{color:var(--content-destructive-secondary);gap:4px;display:flex}.D7iB7wNFuCMMKfOX1P7u{color:var(--content-destructive-primary)}.QuJtfQue00Mzhilf2jZb{color:var(--light-blue-70);cursor:pointer}.QuJtfQue00Mzhilf2jZb:hover{opacity:.9}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `VQwYHLv95kI2qg0II_mb`,
	"errorWrap": `Sg05SFA4KAGs2MKwBxoQ`,
	"errorWrap__icon": `D7iB7wNFuCMMKfOX1P7u`,
	"errorWrapIcon": `D7iB7wNFuCMMKfOX1P7u`,
	"link": `QuJtfQue00Mzhilf2jZb`
};
export default ___CSS_LOADER_EXPORT___;
